import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { PageActions } from '../../components/ui/PageActions.tsx';
import { Link } from 'react-router';
import { useMe } from '../../lib/auth.tsx';
import { useGridQuery, useGridState } from '../../lib/grid.ts';
import { RUN_STATUS, SUBJECT_LABEL, d10, type RunRow } from '../../lib/assessments.ts';
import { DataTable, type Column } from '../../components/DataTable.tsx';
import { Badge, LinkButton } from '../../components/ui/Button.tsx';
import { can } from '../../lib/perm.ts';
import { fmtDate, todayLocal } from '../../lib/date.ts';

const columns: Column<RunRow>[] = [
  { key: 'templateName', label: '점검표', filter: 'text', render: (r) => <Link className="text-accent-strong hover:underline" to={`/assessments/runs/${r.id}`}>{r.templateName}</Link> },
  { key: 'periodLabel', label: '회차', width: '8rem', filter: 'text' },
  { key: 'subjectType', label: '대상', width: '6rem', filter: 'select', render: (r) => r.subjectName || SUBJECT_LABEL[r.subjectType] },
  { key: 'assigneeId', label: '담당자', width: '7rem', filter: 'select', sortable: false, render: (r) => r.assigneeName || '—' },
  { key: 'status', label: '상태', width: '6.5rem', filter: 'select', render: (r) => <Badge tone={RUN_STATUS[r.status]?.tone ?? 'neutral'}>{RUN_STATUS[r.status]?.label ?? r.status}</Badge> },
  { key: 'dueDate', label: '기한', width: '6.5rem', filter: 'date', render: (r) => { const over = r.dueDate && !['confirmed', 'cancelled'].includes(r.status) && r.dueDate.slice(0, 10) < todayLocal(); return <span className={over ? 'text-red-700 font-medium' : ''}>{d10(r.dueDate)}</span>; } },
  { key: 'failCount', label: '부적합', row: 2, span: 1, align: 'right', filter: 'none', render: (r) => r.failCount ? <span className="text-red-700 font-medium">{r.failCount}</span> : '0' },
  { key: 'partialCount', label: '부분', row: 2, span: 1, align: 'right', filter: 'none' },
  { key: 'resultCount', label: '기록', row: 2, span: 1, align: 'right', sortable: false },
  { key: 'confirmedAt', label: '확인 완료', row: 2, span: 1, filter: 'date', render: (r) => fmtDate(r.confirmedAt) },
];

/** 점검 회차 목록 — 서버사이드 그리드 + 수동 생성 */
export function AssessmentRunsPage() {
  const me = useMe();
  const { state, set } = useGridState('ar', { sort: { col: 'dueDate', dir: 'desc' } });
  const data = useGridQuery<RunRow>('assessment-runs-grid', '/assessments/runs/grid', state);
  const isAdmin = can(me.data, 'assessment.manage');
  return (
    <div>
      <PageHeader title="점검 회차" />
      {data.isError && <div className="text-red-600 text-sm mb-2">{(data.error as Error).message}</div>}
      <DataTable id="assessment-runs" columns={columns} data={data.data} state={state} onChange={set} isFetching={data.isFetching} />
      <PageActions>{isAdmin && <LinkButton to="/assessments/runs/new">회차 수동 생성</LinkButton>}</PageActions>
    </div>
  );
}
